import classNames from 'classnames';
import { formatCents, PriceBreakdown } from '../../../lib/checkout/pricing';
import styles from './OrderSummary.module.scss';

export interface OrderSummaryProps {
  breakdown: PriceBreakdown;
}

/**
 * The itemised total, shared by the bag and the checkout screen.
 *
 * Purely presentational: every figure comes from `PriceBreakdown`, which is built from server-side
 * pricing, so this component has no arithmetic of its own and cannot drift from what will be charged.
 * The prototype shows the same total on both screens on purpose ("same total, third time they've seen
 * it"), which is why this is one component rather than two.
 */
export default function OrderSummary({ breakdown }: OrderSummaryProps) {
  return (
    <div className={styles.summary}>
      {breakdown.lines.map((line) => {
        return (
          <div className={styles.row} key={line.label}>
            <span className={styles.label}>{line.label}</span>
            <span className={classNames(styles.amount, { [styles.credit]: line.isCredit })}>
              {/* a credit is signed rather than coloured alone, so it reads correctly in mono too */}
              {line.isIncluded ? 'Included' : `${line.isCredit ? '−' : ''}${formatCents(line.amountInCents)}`}
            </span>
          </div>
        );
      })}

      <div className={classNames(styles.row, styles.totalRow)}>
        <span className={styles.totalLabel}>Total today</span>
        <span className={styles.totalAmount}>{formatCents(breakdown.totalInCents)}</span>
      </div>
    </div>
  );
}
